<template>
    <div class="inner">
        <div class="header white">
            <span>submit your testimonial</span>
        </div>
        <div class="speakerForm">
            <form action="#">
                <div class="speakerPic">
                    <div class="speaker">
                        <img src="../../../public/assets/images/s.png" alt="speaker">
                        <div class="title">Karim Awad</div>
                        <div class="description">Group CEO and Chairman of the Executive Committee, EFG
                            Holding
                        </div>
                    </div>
                </div>
                <div class="formspeaker">
                    <label for="FirstName">First Name<span>*</span></label>
                    <input type="text" name="FirstName" id="FirstName">

                    <label for="LastName">Last Name<span>*</span></label>
                    <input type="text" name="LastName" id="LastName">

                    <label for="EmailAddress">Email Address<span>*</span></label>
                    <input type="email" name="EmailAddress" id="EmailAddress">

                    <label for="Companies">Company Name<span>*</span></label>
                    <select name="Companies" id="Companies">
                        <option value="Egypt">Egypt</option>
                        <option value="Egypt">Egypt</option>
                        <option value="Egypt">Egypt</option>
                    </select>

                    <label for="message">Add you message here<span>*</span></label>
                    <textarea name="message" id="message"></textarea>

                    <!-- upload your photo -->
                    <input type="file" name="photo" id="photo">
                    <button class="btn_x" type="submit"> Submit </button>
                </div>
            </form>
        </div>

        
        <div class="header white">
            <span>testimonials</span>
        </div>
        <div class="speakers">
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>
